export default {
  attach: function attach() {},
  detach: function detach() {}
};